import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import {
  AdminBatchCounterSchema,
  AdminBatchCriteriaSchema,
  AdminBatchSchema,
  AdminBatchStatusSchema,
  AdminImportBatchBodySchema,
  AdminResetReportsByPeriodBodySchema,
} from './schemas';

const c = initContract();

export const adminBatchContract = c.router({
  getBatches: {
    method: 'POST',
    path: '/admin/batches',
    body: z.object({ criteria: AdminBatchCriteriaSchema }),
    responses: {
      200: z.object({
        data: z.object({
          list: z.array(AdminBatchSchema),
          totalItems: z.number(),
        }),
      }),
    },
  },
  retrieveBatchLrns: {
    method: 'GET',
    path: '/admin/retrieve-batch-lrns/:batchCounter',
    pathParams: z.object({ batchCounter: AdminBatchCounterSchema }),
    responses: {
      200: z.object({ data: z.array(z.string()) }),
    },
  },
  exportBatch: {
    method: 'GET',
    path: '/admin/export-batch/:batchId',
    pathParams: z.object({ batchId: z.string() }),
    responses: {
      200: c.otherResponse({
        contentType: 'application/zip',
        body: z.unknown(),
      }),
    },
  },
  importBatch: {
    method: 'POST',
    path: '/admin/import-batch',
    contentType: 'multipart/form-data',
    body: AdminImportBatchBodySchema,
    responses: {
      201: z.object({ message: z.string() }),
      400: z.object({ message: z.string() }),
    },
  },
  resetBatch: {
    method: 'POST',
    path: '/admin/reset-batch/:batchId',
    pathParams: z.object({ batchId: z.string() }),
    body: c.noBody(),
    responses: { 200: z.object({ data: z.any() }) },
  },
  updateBatchStatus: {
    method: 'PATCH',
    path: '/admin/batch-status/:batchId',
    pathParams: z.object({ batchId: z.string() }),
    body: z.object({ status: AdminBatchStatusSchema }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  resetBatchCustomsReport: {
    method: 'PATCH',
    path: '/admin/batch-reset-customs-report/:batchId',
    pathParams: z.object({ batchId: z.string() }),
    body: z.object({ hardReset: z.boolean() }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  resetBatchUtbReport: {
    method: 'PATCH',
    path: '/admin/batch-reset-utb-report/:batchId',
    pathParams: z.object({ batchId: z.string() }),
    body: z.object({ hardReset: z.boolean() }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  countBatchesByPeriod: {
    method: 'POST',
    path: '/admin/batches-count-by-period',
    body: AdminResetReportsByPeriodBodySchema,
    responses: {
      200: z.object({ count: z.number() }),
    },
  },
  resetReportsByPeriod: {
    method: 'POST',
    path: '/admin/batches-reset-reports-by-period',
    body: AdminResetReportsByPeriodBodySchema,
    responses: {
      200: z.object({ resetCount: z.number() }),
    },
  },
});
